import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import WOW from 'wowjs';
import '../../Styles/home.css'
const Home = () => {
    useEffect(() => {
        AOS.init({ duration: 800 })
      }, [])
    
      useEffect(() => {
        new WOW.WOW().init();
      }, []);
    
      return (
        <div className="home-container">
          <h1 class="wow bounceInLeft" data-wow-duration="1s" data-wow-delay="0s">DEVELOPER</h1>
          <h1 class="wow bounceInRight" data-wow-duration="1s" data-wow-delay="1s">HONG SE HYUN</h1>
        </div>
      )
}

export default Home